exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab1-shape[data-v-c97d99a0]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:10px 24px;color:#555}.selected-tab1[data-v-c97d99a0]{border:1px solid #ccc;border-bottom:0;color:#555;border-top-left-radius:3px;border-top-right-radius:3px}", ""]);

// exports
